import { TradingAccountActivityPerGroupingDto } from './TradingAccountActivityPerGroupingDto'

export interface WelcomeAccountDeviceActivityDto {
  deviceKey: string | null
  count: number
  welcomeAccounts: TradingAccountActivityPerGroupingDto[]
}

export enum WelcomeAccountDeviceActivityDtoKey {
  deviceKey = 'deviceKey',
  count = 'count',
}
